import React from "react";

const StoresIcon = props => {
  const color = props.color;
  return (
    <svg width={19} height={22} {...props}>
      <title>market-stand</title>
      <path
        fill={color}
        d="M18.916 8.167l-1.572-5.818a2.186 2.186 0 0 0-.212-.504A1.174 1.174 0 0 0 16.17 0H2.72a1.174 1.174 0 0 0-.83 2.005c-.088.155-.16.32-.207.494L.111 8.317C-.1 9.105.208 9.77.813 9.928V21.45h17.5V9.74c.536-.204.803-.832.603-1.573zm-5.041-4.844l1.328 4.916c.02.077.05.15.08.224-.593.97-1.455 1.392-2.394 1.159-.824-.205-1.4-.837-1.412-1.286V3.55c0-.077-.011-.152-.023-.227h2.42zM3.825 8.39l1.368-5.067h2.304a1.45 1.45 0 0 0-.023.227v4.876l-.003-.002c-.548 1.037-1.394 1.5-2.322 1.269-.769-.19-1.305-.784-1.305-1.198h-.058c.013-.035.029-.069.039-.105zm9.54 11.864h-9.44v-3.776h1.694a1.044 1.044 0 0 1 1.909 0h3.448c.049-.532.491-.95 1.036-.95.544 0 .987.418 1.035.95h.319v3.776zm-7.497-5.136a.737.737 0 1 1 1.474.001.737.737 0 0 1-1.474 0zm5.439-.327a.736.736 0 1 1 1.473 0 .736.736 0 0 1-1.473 0zm6.1 5.753h-1.159v-7.64H2.956v7.64H1.72V9.977l.266.006c.63.012 1.286-.46 1.642-1.118.203.491.772.954 1.449 1.122.132.032.316.064.533.064.533 0 1.26-.196 1.867-1.056.011.82.68 1.189 1.508 1.189h.982c.713 0 1.307-.496 1.466-1.161.292.402.802.748 1.384.892.141.035.34.07.57.07.587 0 1.389-.222 2.05-1.203.362.622.996 1.062 1.604 1.05l.365-.007v10.719z"
        fillRule="nonzero"
      />
    </svg>
  );
};
export default StoresIcon;



// WEBPACK FOOTER //
// ./src/components/Menu/MenuIcons/StoresIcon.js